import React, { createContext, useContext, useState, ReactNode } from 'react';
import { LanguageManager, SUPPORTED_LANGUAGES } from '../config/translations';
import { useTranslation } from '../config/translations';
import type { LanguageContextType } from '../types';

const LanguageContext = createContext<LanguageContextType>({
  language: 'en',
  changeLanguage: () => {},
  t: (key: string) => key,
  SUPPORTED_LANGUAGES,
});

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<string>(LanguageManager.getCurrentLanguage());

  const changeLanguage = (lang: string): void => {
    if (LanguageManager.setLanguage(lang)) {
      setLanguage(lang);
    }
  };

  const t = useTranslation(language as any);

  const value: LanguageContextType = {
    language,
    changeLanguage,
    t,
    SUPPORTED_LANGUAGES,
  };

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => useContext(LanguageContext); 